"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const createSvgIcon_1 = __importDefault(require("../utils/createSvgIcon"));
exports.default = (0, createSvgIcon_1.default)(react_1.default.createElement("g", null,
    react_1.default.createElement("path", { fillRule: "evenodd", d: "M19.2803 6.9697a.75.75 0 0 1 0 1.0606l-8.8446 8.8447c-.5858.5858-1.5356.5858-2.1214 0l-3.5946-3.5947a.75.75 0 0 1 1.0607-1.0606l3.5946 3.5946 8.8447-8.8446a.75.75 0 0 1 1.0606 0Z", clipRule: "evenodd" })), 'CheckIcon');
